<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="info" v-b-tooltip.hover :title="showToolTip ? 'Информация' : ''"><i class="fa fa-info-circle"></i></b-button>
</template>

<script>

export default ({
  name: "button-info",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
